import type { Period } from '../../types/common';

type PrefectureCode =
  | '01'
  | '02'
  | '03'
  | '04'
  | '05'
  | '06'
  | '07'
  | '08'
  | '09'
  | '10'
  | '11'
  | '12'
  | '13'
  | '14'
  | '15'
  | '16'
  | '17'
  | '18'
  | '19'
  | '20'
  | '21'
  | '22'
  | '23'
  | '24'
  | '25'
  | '26'
  | '27'
  | '28'
  | '29'
  | '30'
  | '31'
  | '32'
  | '33'
  | '34'
  | '35'
  | '36'
  | '37'
  | '38'
  | '39'
  | '40'
  | '41'
  | '42'
  | '43'
  | '44'
  | '45'
  | '46'
  | '47';

const JAPAN_GAD_REGEX =
  /^gadalljp_01_(0[1-9]|[1-3][0-9]|4[0-7])_(20[0-9]{2})(0[1-9]|1[0-2])_(w|h)_[^_]*_([0-9]{2})/;

const PREFECTURE_CODE_REGEX = /^(0[1-9]|[1-3][0-9]|4[0-7])$/;

const isJapanSimData = (simdataId: string): boolean => {
  return JAPAN_GAD_REGEX.test(simdataId);
};

const isPrefectureCode = (code: string): code is PrefectureCode => {
  return PREFECTURE_CODE_REGEX.test(code);
};

const getPeriod = (
  simdataId: string
): (Period & { prefectureCode: string; version: number }) | null => {
  const match = simdataId.match(JAPAN_GAD_REGEX);
  if (match) {
    return {
      key: `${match[2]}-${match[3]}-${
        match[4] === 'w' ? 'weekday' : 'holiday'
      }`,
      prefectureCode: match[1],
      year: Number(match[2]),
      month: Number(match[3]),
      dayType: match[4] === 'w' ? 'weekday' : 'holiday',
      version: Number(match[5]),
    };
  }
  return null;
};

const getPrefectureCode = (simdataId: string): PrefectureCode | null => {
  const match = simdataId.match(JAPAN_GAD_REGEX);
  if (match && isPrefectureCode(match[1])) {
    return match[1];
  }
  return null;
};

export { isJapanSimData, isPrefectureCode, getPeriod, getPrefectureCode };
